import { createAsyncThunk } from "@reduxjs/toolkit"

// The platform session is entirely Clerk-driven; there is no per-session
// service state to restore anymore (the legacy AWS-token/session machinery
// was removed with the legacy backend decoupling).
export const initializeUser = createAsyncThunk<void, void>(
  "user/initializeUser",
  async () => undefined
)
